export const UPDATE_FILTER_DATA = "UPDATE_FILTER_DATA";

export function updateFilterData(filterData) {
  return {
    type: UPDATE_FILTER_DATA,
    filterData,
  };
}
